import type { Directive, DirectiveBinding } from 'vue'

interface DebounceOptions {
  fn: (...args: unknown[]) => void
  delay?: number
  event?: keyof HTMLElementEventMap
}

type DebounceElement = HTMLElement & { __debounceTimer__?: number }

/**
 * 防抖指令：v-debounce="handleClick" / v-debounce="{ fn: handleClick, delay: 500, event: 'click' }"
 */
export const debounce: Directive<DebounceElement, DebounceOptions | ((...args: unknown[]) => void)> = {
  mounted(el, binding: DirectiveBinding<DebounceOptions | ((...args: unknown[]) => void)>) {
    const options: DebounceOptions =
      typeof binding.value === 'function' ? { fn: binding.value } : binding.value
    const delay = options.delay ?? 300
    const event = options.event ?? 'click'
    el.addEventListener(event, () => {
      if (el.__debounceTimer__) window.clearTimeout(el.__debounceTimer__)
      el.__debounceTimer__ = window.setTimeout(() => options.fn(), delay)
    })
  },
  unmounted(el) {
    if (el.__debounceTimer__) window.clearTimeout(el.__debounceTimer__)
  },
}

export default debounce
